const state = {
  presentationMode:
    localStorage.getItem("presentationMode") === "true" || false,
  sensitiveTexts: []
};

const mutations = {
  TOGGLE_PRESENTATION_MODE(state) {
    state.presentationMode = !state.presentationMode;
    localStorage.setItem("presentationMode", state.presentationMode);
  },
  SET_PRESENTATION_MODE(state, value) {
    state.presentationMode = value;
    localStorage.setItem("presentationMode", state.presentationMode);
  },
  SET_SENSITIVE_TEXTS(state, texts) {
    state.sensitiveTexts = texts.map((t) => t.toLowerCase());
  }
};

const actions = {
  togglePresentationMode({ commit }) {
    commit("TOGGLE_PRESENTATION_MODE");
  },
  setPresentationMode({ commit }, value) {
    commit("SET_PRESENTATION_MODE", value);
  },
  setSensitiveTexts({ commit, dispatch }, texts) {
    commit("SET_SENSITIVE_TEXTS", texts);
    dispatch("applyGlobalBlur");
  },
  // Busca e aplica blur em toda a página
  applyGlobalBlur({ state }) {
    if (typeof window === "undefined") return;

    // Remover todos os blurs existentes
    document.querySelectorAll(".presentation-blur-auto").forEach((el) => {
      el.classList.remove("presentation-blur-auto");
      if (el._originalContent) {
        el.textContent = el._originalContent;
        delete el._originalContent;
      }
    });

    if (!state.presentationMode || state.sensitiveTexts.length === 0) {
      return;
    }

    const processNode = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent;
        const textLower = text.toLowerCase();

        for (const sensitiveText of state.sensitiveTexts) {
          if (textLower.includes(sensitiveText)) {
            const span = document.createElement("span");
            span.className = "presentation-blur-auto";
            span.textContent = text;
            span._originalContent = text;

            const parent = node.parentNode;
            parent.replaceChild(span, node);
            return;
          }
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        const tagName = node.tagName.toLowerCase();
        if (
          [
            "script",
            "style",
            "noscript",
            "iframe",
            "input",
            "textarea",
            "select"
          ].includes(tagName)
        ) {
          return;
        }

        // Processar filhos
        const children = Array.from(node.childNodes);
        children.forEach((child) => processNode(child));
      }
    };

    // Processar body inteiro
    processNode(document.body);
  }
};

const getters = {
  isPresentationMode: (state) => state.presentationMode,
  sensitiveTexts: (state) => state.sensitiveTexts
};

export default {
  state,
  mutations,
  actions,
  getters
};
